import React, { useEffect, useState } from 'react';
import './EventsView.scss'
import firebase, { storage } from '../../../utils/firebase'
import logo1 from '../../../assets/cropped-logo_white.png'
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentTab } from '../../../redux/actions/adminSideMenuAction';
import Helmet from 'react-helmet'
import CommentsComponent from './CommentsComponent';
import Alert from '../Alert';
import { setEventAlert } from '../../../redux/actions/adminActions';
import Paginate from '../Pagination';


const EventsView = () => {
    const [eventName, setEventName] = useState('')
    const [eventStatus, setEventStatus] = useState('')
    const [eventDescription, setEventDescription] = useState('')
    const [eventType, setEventType] = useState('')
    const [eventImageUrl, setEventImageUrl] = useState('');
    const [streamUrl, setStreamUrl] = useState('')
    const [createdBy, setCreatedBy] = useState('')
    const [eventDate, setEventDate] = useState('')
    const [eventTime, setEventTime] = useState('')
    const [eventData, setEventData] = useState([])
    const [eventImage, setEventImage] = useState('');
    const [updateImage, setUpdateImage] = useState('');
    const [echange, setEchange] = useState(true)
    const [edit, setEdit] = useState(false)
    const [editId, setEditId] = useState('')
    const [uploadProgress, setUploadProgress] = useState('kk');
    const [uploadStage, setUploadStage] = useState('');
    const [uploadClick, setUploadClick] = useState(false);
    const [updateStatus, setUpdateStatus] = useState('');
    const [updateDescription, setUpdateDescription] = useState('');
    const [updateName, setUpdateName] = useState('');
    const [updateType, setUpdateType] = useState('');
    const [updateStreamUrl, setUpdateStreamUrl] = useState('');
    const [updateDate, setUpdateDate] = useState('');
    const [updateid, setUpdateid] = useState('');
    const [updateTime, setUpdateTime] = useState('');
    const [eventCreate, setEventCreate] = useState(false);
    const [updateCreatedBy, setUpdateCreatedBy] = useState('');
    const [updateCreate, setUpdateCreate] = useState(false);
    const [copied, setCopied] = useState(false);
    const [offset, setOffset] = useState(10)
    const [noOfPages, setNoOfPages] = useState('')
    const [pageArray, setPageArray] = useState([])
    const [noOfData, setNoOfData] = useState('')
    const [loadedData, setLoadedData] = useState([])
    const [activePage, setActivePage] = useState(1)
    const [alertMessage, setAlertMessage] = useState('')
    const [deleteId, setDeleteId] = useState('')
    const alert = useSelector(state => state.alert)
    const [pageState, setPageState] = useState('')
    const [nn, setnn] = useState('')
    const { eventAlertStatus } = alert
    const dispatch = useDispatch()

    const numArr = (num) => {
        const arr = []
        for (let i = 1; i <= num ; i++) {
          arr.push(i)
        }
        return arr
      }

    useEffect(() => {    
        setNoOfPages(Math.ceil((eventData.length)/10))
        setNoOfData(eventData.length)
        setOffset(10 * activePage)
        setLoadedData(eventData.slice((offset - 10), offset))
        setPageArray(numArr(noOfPages))
    }, [activePage, eventData, noOfData, noOfPages, offset])

    useEffect(() => {
        if(pageArray.length > 0) {
            document.querySelectorAll('.page-box').forEach(el => {
                el.classList.remove('active')
            })
            if(document.querySelector(`.page${activePage}`) === null) {   
                setActivePage(pageState - 1)
            } else {   
                return document.querySelector(`.page${activePage}`).classList.add('active')
            }
        }
        
    }, [activePage, eventData, pageArray, pageArray.length, pageState])

    const makeUpload = (file, fileName) => {
        const uploadTask = storage.ref(`/images/${fileName}`).put(file)
            //initiates the firebase side uploading 
            uploadTask.on('state_changed', 
            (snapShot) => {
                const progress = Math.round((snapShot.bytesTransferred / snapShot.totalBytes) * 100)
                setUploadProgress(progress)
                setUploadStage('loading')
            //takes a snap shot of the process as it is happening
            }, (err) => {
            //catches the errors
            setUploadProgress(err)
            }, () => {      }
            )
    }

    useEffect(() => {
        if(copied) {
            setTimeout(() => {
                setCopied(false)
            }, 2000);
        }
    }, [copied]);

    useEffect(() => {
        if(updateCreate) {
            if(uploadProgress === 100) {
                setUploadProgress('Uploading')   
                setTimeout(() => {    
                    storage.ref('images').child(eventImage.name).getDownloadURL()
                    .then(fireBaseUrl => {
                    setUpdateImage(fireBaseUrl)
                    })
                }, 2000);

                
            }
        }

        if(eventCreate) {
            if(uploadProgress === 100) {
                setUploadProgress('Uploading')
                setTimeout(() => {
                    storage.ref('images').child(eventImage.name).getDownloadURL()
                    .then(fireBaseUrl => {
                        setEventImageUrl(fireBaseUrl)
                    })     
                }, 2000);
            }
        }
        
    }, [eventCreate, eventImage.name, updateCreate, uploadProgress])

    useEffect(() => {
        if (eventCreate) {
            if (eventImageUrl) {    
                const eventRef = firebase.database().ref('Events')
                let event = {
                        eventName: eventName,
                        eventType: eventType,
                        description: eventDescription,
                        streamUrl: streamUrl,
                        eventDate: eventDate,
                        eventTime: eventTime,
                        eventImageUrl: eventImageUrl,
                        whoCreatedIt: createdBy,
                        eventStatus: eventStatus,
                        createdAtDate: Date.now()
                    }
    
                eventRef.push(event)
                setEchange(!echange)
                setCreatedBy('')
                setEventDescription('')
                setEventName('')
                setEventType('')
                setStreamUrl('')
                setEventStatus('')
                setEventDate('')
                setEventTime('')
                setEventImageUrl('')
                setUploadProgress('')
                setEventImage('')
                setUploadStage('')
                setUploadClick(false)
                document.querySelector('.admin-background').classList.add('hide')
                document.querySelector('.event-form-container').classList.add('hide')
                setEdit(false)
                setEditId('')
                setEventCreate(false)
            }
        }
    }, [createdBy, echange, eventCreate, eventDate, eventDescription, eventImageUrl, eventName, eventStatus, eventTime, eventType, streamUrl]);

    useEffect(() => {
        if (updateCreate) {      
            if(updateImage) {
            
                if(eventStatus === 'Default') {
                    setUpdateStatus('Default')
                    eventData.forEach(el => {
                        if (el.eventStatus === 'Default') {
                            const eventRef = firebase.database().ref('Events').child(el.id)
                                eventRef.update({
                                eventStatus: 'Not Live'
                            })
                        } 
                    })
                }
        
                if(eventStatus === 'Live') {
                    setUpdateStatus('Live')
                    eventData.forEach(el => {
                        if (el.eventStatus !== 'Default') {
                            const eventRef = firebase.database().ref('Events').child(el.id)
                                eventRef.update({
                                eventStatus: 'Not Live'
                            })
                        } 
                    })
                }
        
                setEventDescription(updateDescription)
                setEventName(updateName)
                setEventType(updateType)
                setStreamUrl(updateStreamUrl)
                setEventStatus(updateStatus)
                setEventDate(updateDate)
                setEventTime(updateTime)
                setCreatedBy(updateCreatedBy)

                const eventRef = firebase.database().ref('Events').child(updateid)
                eventRef.update({
                    eventName: eventName,
                    eventType: eventType,
                    description: eventDescription,
                    streamUrl: streamUrl,
                    eventDate: eventDate,
                    eventTime: eventTime,
                    eventImageUrl: updateImage,
                    whoCreatedIt: createdBy,
                    eventStatus: updateStatus,
                    updatedAtDate: Date.now()
                })

                setUpdateid('')
                setUpdateImage('')
                setEchange(!echange)
                setCreatedBy('')
                setEventDescription('')
                setEventName('')
                setEventType('')
                setStreamUrl('')
                setEventStatus('')
                setEventDate('')
                setEventTime('')
                setEventImageUrl('')
                setUploadProgress('')
                setEventImage('')       
                setUploadStage('')
                setUploadClick(false)
                document.querySelector('.admin-background').classList.add('hide')
                document.querySelector('.event-form-container').classList.add('hide')
                setEdit(false)
                setEditId('')
                setUpdateName('')
                setUpdateDescription('')
                setUpdateType('')
                setUpdateStreamUrl('')
                setUpdateCreatedBy('')
                setUpdateStatus('')
                setUpdateTime('')
                setUpdateDate('')
                setUpdateCreate(false)
            }
        }
    }, [createdBy, echange, eventData, eventDate, eventDescription, eventName, eventStatus, eventTime, eventType, streamUrl, updateCreate, updateCreatedBy, updateDate, updateDescription, updateImage, updateName, updateStatus, updateStreamUrl, updateTime, updateType, updateid]);

    useEffect(() => {
        dispatch(getCurrentTab('events'))
    }, [dispatch])

    useEffect(() => {
        const eventRef = firebase.database().ref('Events')
        eventRef.on('value', (el) => {
            let eData = []
            for (let id in el.val()) {
                eData.unshift({id, ...el.val()[id]})
            }
            setEventData(eData)
            console.log('look below 249')
            console.log(eData)
        })
    }, [echange])

    useEffect(() => {
        if (eventAlertStatus) {
            if(deleteId) {
                const eventRef = firebase.database().ref('Events').child(deleteId)
                eventRef.remove()
                setEchange(!echange)
                dispatch(setEventAlert(false))
                setDeleteId('')
            }
            
        }
    }, [deleteId, dispatch, echange, eventAlertStatus])

    const handleCloseEventForm = (e) => {
        e.preventDefault()
        if (uploadClick) {
            return
        }

        setEdit(false)
        document.querySelector('.admin-background').classList.add('hide')
        document.querySelector('.event-form-container').classList.add('hide')
        setCreatedBy('')
        setEventDescription('')
        setEventName('')
        setEventType('')
        setStreamUrl('')
        setEventStatus('')
        setEditId('')
        setEventDate('')
        setEventTime('')
        setEventImage('')
        setUploadStage('')
        setEventImageUrl('')
        setUploadClick(false)
        setEventCreate(false)
        setUpdateCreate(false)
    }

    const handleOpenEventForm = () => {
        document.querySelector('.admin-background').classList.remove('hide')
        document.querySelector('.event-form-container').classList.remove('hide')
        document.querySelector(`.event-form-container`).scrollIntoView(); 
    }

    const handleSubmitEventForm = (e) => {
        e.preventDefault()
        setUploadClick(true)
        setEventCreate(true)

        if(!eventName || !eventStatus || !eventDescription || !eventType || !streamUrl || !createdBy || !eventDate || !eventTime) {
            setUploadClick(false)
            setUploadStage('fail')
            setUploadProgress('Please Complete The Compulsory Fields')
            return
        }

        if(eventImage === '' ) {
            setUploadClick(false)
            setUploadStage('fail')
            setUploadProgress('Please Upload An Image')
            return console.log(`not an image, the image file is a ${typeof(eventImage)}`)
        } 

        if(eventStatus === 'Default') {
            eventData.forEach(el => {
                if (el.eventStatus === 'Default') {
                    const eventRef = firebase.database().ref('Events').child(el.id)
                        eventRef.update({
                        eventStatus: 'Not Live'
                    })
                } 
            })
        }

        if(eventStatus === 'Live') {
            eventData.forEach(el => {
                if (el.eventStatus != 'Default') {
                    const eventRef = firebase.database().ref('Events').child(el.id)
                        eventRef.update({
                        eventStatus: 'Not Live'
                    })
                } 
            })
        }

        makeUpload(eventImage, eventImage.name)
    }

    const handleEventDelete = (id, name, index) => {
        setDeleteId(id)
        setPageState(activePage)
        setAlertMessage(`You are about to delete "${name}" \n\nNote this event will be deleted together with all user comments made during this event! \n\nAre you sure you want to proceed?`)
        document.querySelector(`.a${id}`).classList.remove('hide')
        let elmnt = document.querySelector(".content-view");
        let y = elmnt.scrollHeight;
        document.querySelector('.admin-background').classList.remove('hide')
        document.querySelector('.admin-background').style.height = `${y + 110}px`
        if((index + 1) >= 4) {
            document.querySelector(`.a${id}`).scrollIntoView();   
        }
         
    }

    const handleEventClone = (id) =>{
        let event
        const allEventRef = firebase.database().ref('Events')
        const eventRef = firebase.database().ref('Events').child(id)
         eventRef.on('value', (el) => {  
            let check = 'Not Live'
             if(eventStatus === 'Default') {
                check = 'Default'
                eventData.forEach(el => {
                    if (el.eventStatus === 'Default') {
                        const eventRef = firebase.database().ref('Events').child(el.id)
                            eventRef.update({
                            eventStatus: 'Not Live'
                        })
                    } 
                })
            }
            if(eventStatus === 'Live') {
                check = 'Live'
                eventData.forEach(el => {
                    if (el.eventStatus != 'Default') {
                        const eventRef = firebase.database().ref('Events').child(el.id)
                            eventRef.update({
                            eventStatus: 'Not Live'
                        })
                    } 
                })
            }
            event = {             
                eventName: el.val().eventName,
                eventType: el.val().eventType,
                description: el.val().description,
                eventDate: el.val().eventDate,
                eventTime: el.val().eventTime,
                streamUrl: el.val().streamUrl,
                eventImageUrl: el.val().eventImageUrl,
                whoCreatedIt: el.val().whoCreatedIt,
                eventStatus: check,
                createdAtDate: Date.now()
            }
            
        })
        allEventRef.push(event)
        setEchange(!echange)
    }

    const handleEventEdit = (id) => {
        setEdit(true)
        setEditId(id)
        const eventRef = firebase.database().ref('Events').child(id)
        eventRef.on('value', (el) => {    
            setEventDescription(el.val().description)
            setEventName(el.val().eventName)
            setEventType(el.val().eventType)
            setStreamUrl(el.val().streamUrl)
            setEventStatus(el.val().eventStatus)
            setEventDate(el.val().eventDate)
            setEventTime(el.val().eventTime)
            setCreatedBy(el.val().whoCreatedIt)
            setEventImageUrl(el.val().eventImageUrl)
            })
        document.querySelector('.admin-background').classList.remove('hide')
        document.querySelector('.event-form-container').classList.remove('hide')
        document.querySelector(`.admin-nav`).scrollIntoView(); 
    }

    const handleUpdateEventForm = (e, id) => {
        e.preventDefault()
        setUpdateid(id)
        setUploadClick(true)
        setUpdateCreate(true)
        if(!eventName || !eventStatus || !eventDescription || !eventType || !streamUrl || !createdBy || !eventDate || !eventTime) {
            setUploadClick(false)
            setUploadStage('fail')
            setUploadProgress('Please Complete The Compulsory Fields')
            return
        }

        setUpdateName(eventName)
        setUpdateDescription(eventDescription)
        setUpdateType(eventType)
        setUpdateStreamUrl(streamUrl)
        setUpdateCreatedBy(createdBy)
        setUpdateStatus(eventStatus)
        setUpdateTime(eventTime)
        setUpdateDate(eventDate)

        if(eventImage === '' ) {
            if(eventStatus === 'Default') {
                setUpdateStatus('Default')
                eventData.forEach(el => {
                    if (el.eventStatus === 'Default') {
                        const eventRef = firebase.database().ref('Events').child(el.id)
                            eventRef.update({
                            eventStatus: 'Not Live'
                        })
                    } 
                })
            }
    
            if(eventStatus === 'Live') {
                setUpdateStatus('Live')
                eventData.forEach(el => {
                    if (el.eventStatus !== 'Default') {
                        const eventRef = firebase.database().ref('Events').child(el.id)
                            eventRef.update({
                            eventStatus: 'Not Live'
                        })
                    } 
                })
            }
    
            setEventDescription(updateDescription)
            setEventName(updateName)
            setEventType(updateType)
            setStreamUrl(updateStreamUrl)
            setEventStatus(updateStatus)
            setEventDate(updateDate)
            setEventTime(updateTime)
            setCreatedBy(updateCreatedBy)

            const eventRef = firebase.database().ref('Events').child(id)
            eventRef.update({
                eventName: eventName,
                eventType: eventType,
                description: eventDescription,
                streamUrl: streamUrl,
                eventDate: eventDate,
                eventTime: eventTime,
                eventImageUrl: eventImageUrl,
                whoCreatedIt: createdBy,
                eventStatus: eventStatus,
                updatedAtDate: Date.now()
            })
            setEchange(!echange)
            setCreatedBy('')
            setEventDescription('')
            setEventName('')
            setEventType('')
            setStreamUrl('')
            setEventStatus('')
            setEventDate('')
            setEventTime('')
            setEventImageUrl('')
            setUploadProgress('')
            setEventImage('')
            setUploadStage('')
            setUploadClick(false)
            document.querySelector('.admin-background').classList.add('hide')
            document.querySelector('.event-form-container').classList.add('hide')
            setEdit(false)
            setEditId('')
            setUpdateName('')
            setUpdateDescription('')
            setUpdateType('')
            setUpdateStreamUrl('')
            setUpdateCreatedBy('')
            setUpdateStatus('')
            setUpdateTime('')
            setUpdateDate('')
        } else {

            makeUpload(eventImage, eventImage.name)
        }
    }

    const handleCopy = () => {
        let copyText = document.getElementById("eventImageUrl");
        copyText.select();
        copyText.setSelectionRange(0, 99999); 
        document.execCommand("copy");
        setCopied(true)
    }


    

    const handleEventComments = (id) => {      
        document.querySelector(`.${id}`).classList.remove('hide')
        let elmnt = document.querySelector(".content-view");
        let y = elmnt.scrollHeight;
        document.querySelector('.admin-background').style.height = `${y + 110}px`
        document.querySelector('.admin-background').classList.remove('hide')
        document.querySelector(`.${id}`).scrollIntoView();     
    }



    

    

    return (
        <div className='events-view'>
            <Helmet htmlAttributes>
                <meta charSet="utf-8" />
                <html lang="en" />
                <title>Admin-Events | LVZConnect</title>
                <meta name="description" content="LVZConnect Admin Events Page" />
            </Helmet>
            <div className="top">
                <div>
                    <img src={logo1} alt="" />
                    <h3>EVENT LIST</h3>
                </div>
                
                <button onClick={handleOpenEventForm}>Add Events +</button>
            </div>

            <div className="table-container">
                <div className="table title">
                    <div className="num dd">#</div>
                    <div className="e-name dd">Event Name</div>
                    <div className="description dd">Description</div>
                    <div className="date dd">Date</div>
                    <div className="status dd">Status</div>
                    <div className="thumbnail dd">Thumbnail</div>
                    <div className="actions dd">Actions</div>
                </div>

                {loadedData.map((el, i) => {
                        return (
                            <div className="table details" key={el.id}>
                                <Alert message={alertMessage} eventId={el.id} action={setEventAlert} />
                                <div className="num dd">{i + 1 + (offset - 10)}</div>
                                <div className="e-name dd">{el.eventName}</div>
                                <div className="description dd">{el.description}</div>
                                <div className="date dd">
                                    <div>{el.eventDate}</div>
                                    <div>{el.eventTime}</div>
                                </div>
                                {el.eventStatus === 'Live'? <div className={`status dd`} >
                                    <div className='red'>{el.eventStatus}</div>
                                </div>: <div className={`status cc dd `} >{el.eventStatus}</div>}
                                <div className="thumbnail dd">
                                    <img src={el.eventImageUrl} alt="" />
                                </div>
                                <div className="actions dd">
                                    <button className='delete' title='Delete' onClick={()=> handleEventDelete(el.id, el.eventName, i)}><i class="fas fa-trash-alt"></i></button>
                                    <button className='edit' title='Edit' onClick={()=> handleEventEdit(el.id)}><i class="fas fa-edit"></i></button>
                                    <button className='clone' title='Clone' onClick={() => handleEventClone(el.id)}><i class="far fa-copy"></i></button>
                                    <button className='clone' title='Comments Made During This Event' onClick={() => handleEventComments(el.id)}><i class="far fa-comment-dots"></i></button>
                                </div>
                                
                                <CommentsComponent eventId={el.id} name={el.eventName}/>
                                
                            </div>
                        )
                    
                    
                })}
            </div>

            

            {loadedData.length > 0? 
                <Paginate activePage={activePage} setActivePage={setActivePage} pageArray={pageArray} noOfPages={noOfPages} /> : 
                ''
            }

            

            

            <div className='event-form-container hide'>
                <div className="form-close" onClick={handleCloseEventForm}>
                    <i class="fas fa-times"></i>
                </div>
                <h3>
                    {edit? 'Edit Event' : 'Add New Event'}
                </h3>

                <form action="">
                    <div className="form-element">
                        <label htmlFor="eventName">Event Name <span>*</span></label>
                        <input disabled={uploadClick} required type="text" id='eventName' name='eventName' className='field' 
                        value={eventName} onChange={(e) => setEventName(e.target.value)}/>
                    </div>

                    <div className="form-element">
                        <label htmlFor="eventType">Event Type <span>*</span></label>
                        <input disabled={uploadClick} type="text" id='eventType' name='eventType' className='field'  required
                        value={eventType} onChange={(e) => setEventType(e.target.value)}/>
                       
                    </div>

                    <div className="form-element">
                        <label htmlFor="streamUrl">Stream url <span>*</span></label>
                        <input disabled={uploadClick} type="text" id='streamUrl' name='streamUrl' className='field'  required
                        value={streamUrl} onChange={(e) => setStreamUrl(e.target.value)}/>
                       
                    </div>

                    <div className="form-element">
                        <label htmlFor="createdBy">Created By <span>*</span></label>
                        <input disabled={uploadClick} type="text" id='createdBy' name='createdBy' className='field'  required
                        value={createdBy} onChange={(e) => setCreatedBy(e.target.value)}/>
                       
                    </div>

                    <div className="form-element">
                        <label htmlFor="eventDate">Event Date <span>*</span></label>
                        <input disabled={uploadClick} type="date" id='eventDate' name='eventDate' className='field'  required 
                        value={eventDate} onChange={(e) => setEventDate(e.target.value)}/>
                       
                    </div>

                    <div className="form-element">
                        <label htmlFor="eventTime">Event Time <span>*</span></label>
                        <input disabled={uploadClick} type="time" id='eventTime' name='eventTime' className='field'  required 
                        value={eventTime} onChange={(e) => setEventTime(e.target.value)}/>
                       
                    </div>

                    <div className="form-element">
                        <label htmlFor="eventStatus">Status <span>*</span></label>
                        <select disabled={uploadClick} name="eventStatus" id="eventStatus" className='field' required
                        value={eventStatus} onChange={(e) => setEventStatus(e.target.value)}>
                            <option value=""></option>
                            <option value="Live">Live</option>
                            <option value="Not Live">Not Live</option>
                            <option value="Default">Default</option>
                        </select>
                        
                    </div>

                    <div className="form-element">
                        <label htmlFor="eventDescription">Description <span>*</span></label>
                        <textarea disabled={uploadClick} name="eventDescription" id="eventDescription" className='field' required
                        value={eventDescription} onChange={(e) => setEventDescription(e.target.value)}></textarea>  
                    </div>

                    {edit? <div className="form-element">
                                <label htmlFor="eventImageUrl">Thumbnail Url</label>
                                <input type='text' name="eventImageUrl" id="eventImageUrl" className='field' required
                                value={eventImageUrl} onChange={(e) => {}}></input> 
                                <div className="event-url-copy" onClick={handleCopy}>
                                   {copied? <i title='Copied' class="fas fa-check-circle"></i> : <i title='Copy to clipboard' class="far fa-copy"></i> } 
                                </div>
                                
                            </div> : ''}

                    <div className="form-element">
                        <label htmlFor="eventImage">Thumbnail {!edit? <span>*</span> : '' }</label>
                        <input disabled={uploadClick} type="file" id="eventImage" name="eventImage" onChange={(e) => { setEventImage(e.target.files[0])
                        console.log(eventImage.name)}}/>
                        
                        
                    </div>

                    <div className='upload-status'>
                        <p>Status:</p>
                        {uploadStage === 'loading'? <p className="loading">{uploadProgress}</p> : uploadStage === 'fail'? <p className="fail">{uploadProgress}</p> : ''}
                        
                    </div> 

                    <div className="buttons">
                        <button className="close" onClick={handleCloseEventForm}>Close</button>
                        {edit? <button type="submit" disabled={uploadClick} className='submit' onClick={(e) => handleUpdateEventForm(e, editId)}>Update Event</button> : <button type="submit" disabled={uploadClick} className='submit' onClick={handleSubmitEventForm}>Save Event</button>}
                    </div>

                    
                </form>
            </div>
        </div>
    )
}

export default EventsView